'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHoc = require('@mindz/react-hoc');

var _List = require('../List');

var _List2 = _interopRequireDefault(_List);

var _SelectModule = require('./Select.module.css');

var _SelectModule2 = _interopRequireDefault(_SelectModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ArrowDown = function ArrowDown(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('path', {
    fill: 'none',
    className: 'imageStroke',
    d: 'M1 1l3.5 4L8 1'
  }));
};

ArrowDown.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '9',
  height: '6',
  viewBox: '0 0 9 6'
};

var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.node = null, _this.state = {
      isDropdownShown: false,
      options: [],
      selectedOption: null
    }, _this.handleOutsideClick = function (event) {
      if (_this.node && !_this.node.contains(event.target)) {
        _this.setState({
          isDropdownShown: false
        });
      }
    }, _this.handleKeyboardArrows = function (event) {
      switch (event.keyCode) {
        case 38:
          event.preventDefault();

          _this.selectItem('previous');

          break;

        case 40:
          event.preventDefault();

          _this.selectItem('next');

          break;

        case 27:
          event.preventDefault();

          _this.setState({
            isDropdownShown: false
          });

          break;

        case 13:
          event.preventDefault();

          _this.setState({
            isDropdownShown: false
          });

          break;

        default:
          break;
      }
    }, _this.handleClick = function (item) {
      var handleChange = _this.props.handleChange;
      handleChange(item.value);
      return _this.setState({
        isDropdownShown: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var children = this.props.children;
      document.addEventListener('click', this.handleOutsideClick, false);
      this.setOptionsFromChildren(children);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var children = nextProps.children;
      this.setOptionsFromChildren(children);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var isDropdownShown = this.state.isDropdownShown;

      if (isDropdownShown) {
        document.addEventListener('keydown', this.handleKeyboardArrows, false);
      } else {
        document.removeEventListener('keydown', this.handleKeyboardArrows, false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
      document.removeEventListener('keydown', this.handleKeyboardArrows, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          cx = _props.cx,
          label = _props.label,
          isReadOnly = _props.isReadOnly;
      var _state = this.state,
          isDropdownShown = _state.isDropdownShown,
          selectedOption = _state.selectedOption;
      return _react2.default.createElement('div', {
        className: cx('root', {
          active: isDropdownShown
        }, {
          selected: !!selectedOption
        }, {
          hasError: this.hasError()
        }, {
          readonly: isReadOnly
        }),
        ref: function ref(node) {
          return _this2.node = node;
        }
      }, _react2.default.createElement('div', {
        className: cx('holder')
      }, _react2.default.createElement('div', {
        className: cx('title'),
        onClick: function onClick() {
          !isReadOnly && _this2.toggleList();
        }
      }, _react2.default.createElement('span', {
        className: cx('text')
      }, selectedOption ? selectedOption.label : ''), _react2.default.createElement('span', {
        className: cx('label')
      }, label)), _react2.default.createElement('div', {
        className: cx('listHolder')
      }, _react2.default.createElement(_List2.default, null, this.renderOptions())), _react2.default.createElement(ArrowDown, {
        className: cx('arrowDown')
      })), this.renderError());
    }
  }, {
    key: 'setOptionsFromChildren',
    value: function setOptionsFromChildren(children) {
      if (!children) {
        return;
      }

      var options = this.getOptionsFromChildren(children);
      var selectedOption = options.find(function (options) {
        return options.selected;
      });
      this.setState({
        options: options,
        selectedOption: selectedOption
      });
    }
  }, {
    key: 'getOptionsFromChildren',
    value: function getOptionsFromChildren(children) {
      return _react2.default.Children.map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            children = _child$props.children,
            selected = _child$props.selected;
        return {
          value: value,
          label: children,
          selected: selected
        };
      });
    }
  }, {
    key: 'renderOptions',
    value: function renderOptions() {
      var _this3 = this;

      var cx = this.props.cx;
      var _state2 = this.state,
          options = _state2.options,
          selectedOption = _state2.selectedOption;
      return options.map(function (item) {
        var id = item.value;
        return _react2.default.createElement('div', {
          key: item.value,
          className: cx({
            active: selectedOption && selectedOption.value === id
          }),
          onClick: function onClick() {
            return _this3.handleClick(item);
          }
        }, item.label);
      });
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      var _props2 = this.props,
          cx = _props2.cx,
          error = _props2.error;

      if (Array.isArray(error)) {
        return _react2.default.createElement('div', {
          className: cx('error', {
            shown: this.hasError()
          })
        }, error[0]);
      }

      return _react2.default.createElement('div', {
        className: cx('error', {
          shown: this.hasError()
        })
      }, error);
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      var error = this.props.error;
      return !!error;
    }
  }, {
    key: 'selectItem',
    value: function selectItem(direction) {
      var handleChange = this.props.handleChange;
      var _state3 = this.state,
          options = _state3.options,
          selectedOption = _state3.selectedOption;

      if (!options.length) {
        return;
      }

      var nextSelectedOption = selectedOption;
      var selectedIndex = options.findIndex(function (option) {
        return selectedOption && option.value === selectedOption.value;
      });

      if (selectedIndex === -1) {
        nextSelectedOption = options[0];
      } else {
        if (direction === 'previous') {
          if (!selectedIndex) {
            nextSelectedOption = options[options.length - 1];
          } else {
            nextSelectedOption = options[selectedIndex - 1];
          }
        }

        if (direction === 'next') {
          if (options.length - 1 === selectedIndex) {
            nextSelectedOption = options[0];
          } else {
            nextSelectedOption = options[selectedIndex + 1];
          }
        }
      }

      handleChange(nextSelectedOption.value);
    }
  }, {
    key: 'toggleList',
    value: function toggleList() {
      this.setState(function (prevState) {
        return {
          isDropdownShown: !prevState.isDropdownShown
        };
      });
    }
  }]);

  return Select;
}(_react.Component);

Select.defaultProps = {
  buttonType: 'button',
  disabled: false,
  list: [],
  handleChange: function handleChange() {},
  isReadOnly: false
};
exports.default = (0, _reactHoc.withStyles)(_SelectModule2.default)(Select);
module.exports = exports.default;